<main>
  <loading-overlay [isLoading]="isLoading"></loading-overlay>
  <!-- header -->
  <header>
    <div class="headline">
      <h1>
        {{
          originalTransferUnit
            ? ('Transfer_Units_Details_Title' | translateWF: 'Transfer Unit Details') + ': ' + originalTransferUnit.number
            : ('Transfer_Units_Details_New' | translateWF: 'New Transfer Unit')
        }}
      </h1>
      <csl-dropdown [enumObject]="statusEnumObject" [enumValueOptions]="roleStatusOptions" [formControl]="status"></csl-dropdown>
    </div>
    <div class="buttons">
      <p-button
        *ngIf="originalTransferUnit?.id && this.status.value! > 0"
        label="{{ 'Transfer_Units_Details_Download_Report' | translateWF: 'Download Report' }}"
        icon="pi pi-download"
        [outlined]="true"
        (click)="downloadReport()"
      >
      </p-button>
      <span class="separator" *ngIf="originalTransferUnit?.id && this.status.value! > 0"></span>
      <p-button
        label="{{ 'Transfer_Units_Details_Save' | translateWF: 'Save' }}"
        (click)="insertTransferUnit()"
        *ngIf="!originalTransferUnit || (canEdit() && !originalTransferUnit)"
      />
      <p-button label="{{ 'Transfer_Units_Details_Cancel' | translateWF: 'Cancel' }}" (click)="cancel()" variant="outlined" />
    </div>
  </header>

  <div class="content">
    <div class="flex">
      @if (!originalTransferUnit) {
        <p-autoComplete
          [formControl]="knittingOrder"
          #knittingOrderSearchRef="cslServerSearch"
          [cslServerSearch]="fetchKnittingOrders"
          [suggestions]="knittingOrderSearchRef.results()"
          field="knittingOrderNumber"
          [dropdown]="true"
        />
      }

      <a target="_blank" rel="noopener noreferrer" [href]="knittingOrderLink" class="ml-5"> {{ knittingOrder.value?.knittingOrderNumber }}</a>
    </div>

    <p-panel [header]="'Transfer_Units_Details_Inventory_Transactions' | translateWF: 'Inventory Transactions'">
      <ng-template pTemplate="icons">
        <!-- QR Scanner Modal -->
        <app-qr-scanner-modal *ngIf="canEdit()" (isScannedCode)="onQrCodeScanned($event)" />
      </ng-template>
      @for (inventoryTransaction of inventoryTransactions; track $index) {
        <app-inventory-transaction
          [canEdit]="canEdit()"
          [readonly]="!canEdit()"
          type="transfer-unit-details"
          [inventoryTransaction]="inventoryTransaction"
          [knittingOrderNumber]="this.knittingOrder.value?.knittingOrderNumber ?? ''"
          [dischargingLotItems]="false"
          [parentInitiator]="this.originalTransferUnit?.initiator ?? null"
          [readonly]="this.status.value! > 0"
        ></app-inventory-transaction>
      }
    </p-panel>
  </div>
</main>
